const SPACE_PATTERN = / /g

export function getQueryValue(searchParams, keys) {
  for (const key of keys) {
    const value = searchParams.get(key)
    if (value) {
      return value
    }
  }
  return ''
}

export function normalizeVerificationCode(code) {
  return String(code || '').trim().replace(SPACE_PATTERN, '+')
}

export function normalizeEmailLikeValue(value) {
  return String(value || '').trim().replace(SPACE_PATTERN, '+')
}
